import React, { Component } from 'react'
import RestaurantSummary from '../RestaurantSummary2'
import { isTagged, isTaggedAny } from '../Tags'
import { backupRestaurantAdmin, deleteRestaurantCreateAdmin, confirmCreateRestaurantAdmin,
addUserPointsAdmin } from '../../../store/actions/restaurantActions'
import { connect } from 'react-redux'
import Message from '../../users/messages'

class AdminRestaurantListCreate extends Component {

  state={
    project:'',
    editorOptions:'',
    createPoints: 5
  }

  onFavorite = this.props.onFavorite;
  
  openFinder = (project) => {
    for(let key in Object.keys(this.props.sortOptions.openList)){
        if (project.id === this.props.sortOptions.openList[key]['id'] && this.props.sortOptions.openList[key]['isOpen']){
          return(true);
        }
      }
    return(false)

  }

  handlePoints = (e) => {
    this.setState({createPoints:e.target.value})
  }

  deleteCreateInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("myModalCreate").style.display = "block";
  }

  closeFunctionCreate =(e)=>{document.getElementById("myModalCreate").style.display = "none";}
  closeFunctionConfirm =(e)=>{document.getElementById("confirmModalCreate").style.display = "none";}
  closeFunctionMessage =(e)=>{document.getElementById("messageModalCreate").style.display = "none";}

  handleDeleteCreate = (e) => {
    e.preventDefault();
    this.props.backupRestaurantAdmin(this.state.project);
    this.props.deleteRestaurantCreateAdmin(this.state.project);
    document.getElementById("myModalCreate").style.display = "none";
  }

  confirmInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("confirmModalCreate").style.display = "block";
  }

  messageInterruptor =(project)=>{
    this.setState({project:project});
    document.getElementById("messageModalCreate").style.display = "block";
  }

  handleConfirm = (e) => {
    e.preventDefault();
    this.props.confirmCreateRestaurantAdmin(this.state.project);
    this.props.deleteRestaurantCreateAdmin(this.state.project);
    this.props.addUserPointsAdmin("create_"+this.state.project.id, this.state.project.authorId, this.state.createPoints);
    document.getElementById("confirmModalCreate").style.display = "none";
  }

  handleCompare = (project) => {
    document.getElementById(project.id+"compare").style.display = "block";
  }

  closeCompare = (project) => {
    document.getElementById(project.id+"compare").style.display = "none";
  }

  handleEditor = (project) => {
    document.getElementById(project.id+"editor").style.display = "block";
  }

  closeEditor = (project) => {
    document.getElementById(project.id+"editor").style.display = "none";
  }

  render(){
    const { projects, favorites, users } = this.props;
    var newProjects = [];
    if (this.props.sortOptions.sortFavorites){
      newProjects = projects.filter(project => (project.id in {...favorites} && favorites[project.id].favorite === true ))
    }
    else{
      newProjects=projects;
    }
    if (this.props.sortOptions.sortOnlineNotMenu){
      newProjects = newProjects.filter(project => (project.orderUrl !== "" ))
    }
    
    if(this.props.sortOptions.sortTags && this.props.sortOptions.sortTags.length>0){
      if (this.props.sortOptions.anyTags){
       newProjects = newProjects.filter(project => (isTaggedAny(project, this.props.sortOptions.sortTags) ))
      }
      else{
        newProjects = newProjects.filter(project => (isTagged(project, this.props.sortOptions.sortTags) ))
      }
    }

    if (this.props.sortOptions.sortOpen && this.props.sortOptions.openList && this.props.sortOptions.openList.length>0){
     newProjects = projects.filter(project => (this.openFinder(project)))
    }
    
    var sortPendingCreate = [];

    for(var cont in newProjects){
        sortPendingCreate.push([newProjects[cont],newProjects[cont]['createdAt'].seconds]);
      }
      sortPendingCreate.sort(function(a, b) {
         return a[1] - b[1];
        });
      var sortedPendingCreate = [];
      for(var sorted in sortPendingCreate){
        sortedPendingCreate.push(sortPendingCreate[sorted][0])
      }

      return(
    <div className="wrapper">

            <div id="myModalCreate" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionCreate}>&times;</span>
                <p>Are you sure you want to delete?</p>
                <p>{this.state.project.name}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleDeleteCreate}>Submit</button>
                </div>
              </div>
            </div>

            <div id="confirmModalCreate" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionConfirm}>&times;</span>
                <p>Are you sure you want to create?</p>
                <p>{this.state.project.name}</p>
                <div className="input-field2" style={{"display": "flex", "justifyContent": "center"}}>
                  <span style={{"display":"flex", "alignItems":"center", "marginRight":"10px"}}>Points:  </span>
                  <input type="number" id="createPoints" name="createPoints" min="0" max="5" value={this.state.createPoints} onChange={this.handlePoints} style={{"width": "30px"}}></input>
                </div>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={this.handleConfirm}>Submit</button>
                </div>
              </div>
            </div>

            <div id="messageModalCreate" className="modal2">
              <div className="modal-content2">
                <span className="close2" onClick={this.closeFunctionMessage}>&times;</span>
                <p>Enter message for</p>
                <p>{this.state.project.name}</p>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <Message project={this.state.project}/>
                </div>
              </div>
            </div>

      <div className="project-list">
      { sortedPendingCreate && sortedPendingCreate.map(project => {
        var timestampPC = new Date(parseInt(project.createdAt.seconds*1000, 10)).toLocaleString();
        return (
        <div key = { project.id } className="container-test">
            <div style={{"padding":"10px"}}>
              <span>{timestampPC}</span>
              <br/>
              <span> {project && users && users.filter(user=>project.authorId === user.id)[0] && users.filter(user=>project.authorId === user.id)[0].firstName + ' ' + users.filter(user=>project.authorId === user.id)[0].lastName} </span>
              <RestaurantSummary key={ project.id + 'pendingCreate' } allContent="" isOpen = {true} distance = {"uncalculated"} onFavorite = {this.onFavorite} project={project} favorite = {false}/>
               <div className = 'adminButtons' style={{"width":"100%", "display": "flex", "justifyContent": "space-around"}}>
                 <button project={project} className="btn pink lighten-1" onClick={()=>{this.deleteCreateInterruptor(project)}}>Delete</button>
                 <button className="btn pink lighten-1" onClick={()=>{this.messageInterruptor(project)}}>Message</button>
                 <button className="btn pink lighten-1" onClick={()=>{this.confirmInterruptor(project)}}>Confirm</button>
               </div>
              <p> </p>
            </div>
        </div>  
        )
      })}  
    </div>
    </div>
    )  
}
}

const mapStateToProps = (state) => {
  return {
    ...state
  }
}


const mapDispatchToProps = dispatch => {
  return {
    deleteRestaurantCreateAdmin: (project) => dispatch(deleteRestaurantCreateAdmin(project)),
    backupRestaurantAdmin: (project) => dispatch(backupRestaurantAdmin(project)),
    confirmCreateRestaurantAdmin: (project) => dispatch(confirmCreateRestaurantAdmin(project)),
    addUserPointsAdmin: (id, userId, points) => dispatch(addUserPointsAdmin(id, userId, points))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AdminRestaurantListCreate) 

